// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__KMLp-","productName":"Table_productName__1P5yg"};